import { FC } from 'react';
import { ABSOLUTE_URL } from '@/helpers/variables';
import { removeAllBrackertsFromString } from '@/helpers/helpers';
import { IBookShortDetail } from '@/interfaces/bookShortDetail.interface';

interface IBookRatingJsonMarkup {
  book: IBookShortDetail;
  authorName: string;
}

const ReadJsonMarkup: FC<IBookRatingJsonMarkup> = ({ book, authorName }) => {
  const pageUrl = `${ABSOLUTE_URL}/avtor/${book.author.alias}/${book.alias}/read/`;
  const isbn = book.book.isbn ? `"isbn": "${book.book.isbn}",` : '';
  const isForFree = book.book.allow_full_free === 1 ? `"isAccessibleForFree": ${true},` : '';

  const getReadJsonMarkup = () => {
    return {
      __html: `{
      "@context": "https://schema.org",
      "@type": "Book",
      "name": "${book.book.title}",
      "description": "${removeAllBrackertsFromString(book.book.description)}",
      "url": "${pageUrl}",
      "image": "${ABSOLUTE_URL}/covers_200/${book.book.external_id}.jpg",
      "author": {
        "@type": "Person",
        "name": "${authorName}"
      },
      "publisher": {
        "@type": "Organization",
        "name": "${book.book.publisher ? book.book.publisher : 'Kuchaknig'}"
      },
      ${isbn}
      "bookFormat": "https://schema.org/EBook ",
      ${isForFree}
      "potentialAction": {
        "@type": "ReadAction",
        "target": "${pageUrl}",
        "name": "Читать онлайн"
        },
        "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "${book.rating}",
        "reviewCount": "${book.voted_users}"
    }}`,
    };
  };

  return <script type="application/ld+json" dangerouslySetInnerHTML={getReadJsonMarkup()} key="product-jsonld" />;
};

export default ReadJsonMarkup;
